<template>
    <span>{{ daysAgoText }}</span>
  </template>
  
  <script>
export default {
	name: 'dateUtils',
	props: {
		date: {
			type: [String, Date],
        required: true,
      },
      emptyText: {
        type: String,
        default: '-',
      },
    },
    computed: {
      daysAgoText() {
        if (!this.date) return this.emptyText;
        const now = new Date();
        const target = new Date(this.date);
        now.setHours(0,0,0,0);
        target.setHours(0,0,0,0);
        const diffMs = now - target;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays < 0) return 'در آینده';
        return `${diffDays} روز پیش`;
      },
    },
  };
  </script>